import React, { useEffect } from "react";

import type { ReactNode } from "react";
import type { ViewProps } from "react-native";

import {
  CardInfo,
  TitleCard,
  IconFA5,
  NameEncomenda,
  Hr,
  ContentCircle,
  ColorCircle,
  OutlineCircle,
  ContainerCircleDescription,
  ContentTextCircleDescription,
  TextWaiting,
  TextWithdrawalWaiting,
  TextWithdrawal,
  TextDelivered,
  FooterCard,
  ContentFooterCard,
  TextDate,
  Date,
  TitleCityName,
  CityName,
  ViewDetails,
} from "./styles";
import { useNavigation } from "@react-navigation/native";

interface CardDeliveryProps extends ViewProps {
  name: string;
  status?: number;
  date: string;
  city: string;
  onPress?: any;
}

export default function CardDelivery({ name, status, date, city, onPress }: CardDeliveryProps) {
  const navigation = useNavigation();

  function getTextFinish() {
    switch(status) {
      case 0: 
        return 'Pendente';
      case 1:
        return 'Entregue';
      case 2:
        return 'Problema Relatado';
      case 3:
        return 'Cancelado';
    }
  }

  return (
    <>
      <CardInfo>
        <TitleCard>
          <IconFA5 name="shipping-fast" size={25} />
          <NameEncomenda>{name ?? 'Não informado'}</NameEncomenda>
        </TitleCard>

        <Hr />
        <ContentCircle>
          {status === 0 && (
            <>
              <ColorCircle />
              <OutlineCircle /> 
            </>
          )}
          {status !== 0 && (
            <>
              <ColorCircle />
              <ColorCircle /> 
            </>
          )}
        </ContentCircle>
        <ContainerCircleDescription>
          <TextWaiting>Pendente</TextWaiting>
          <TextDelivered>{getTextFinish()}</TextDelivered>
        </ContainerCircleDescription>
      </CardInfo>
      <FooterCard>
        <ContentFooterCard>
          <TextDate>Data</TextDate>
          <Date>{date ?? '--/--/----'}</Date>
        </ContentFooterCard>
        <ContentFooterCard>
          <TitleCityName>Cidade</TitleCityName>
          <CityName>{city ?? 'Não informado'}</CityName>
        </ContentFooterCard>
        <ViewDetails onPress={onPress}>Ver detalhes</ViewDetails>
      </FooterCard>
    </>
  );
}
